import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const SsgcBill = createAsyncThunk(
  "bill/ssgc",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;

      if (id) {
        // 🔵 Tenant side (Update)
        response = await axios.post(
          `${BASE_URL}/update-ssgc-reading/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // 🟢 Owner side (Create)
        response = await axios.post(
          `${BASE_URL}/ssgc-reading`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);





const SsgcReading = createSlice({
  name: "ssgcReading",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(SsgcBill.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SsgcBill.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(SsgcBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default SsgcReading.reducer;

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { BASE_URL } from "../../config/config";

// export const SsgcBill = createAsyncThunk(
//   "bill/SsgcReading",
//   async ({ id, formData }, { rejectWithValue }) => {
//     try {
//       let response;

//       if (id) {
//         // 🔵 Tenant side (Update)
//         response = await axios.post(
//           `${BASE_URL}/update-ssgc-reading/${id}`,
//           formData,
//           {
//             headers: { "Content-Type": "multipart/form-data" },
//           }
//         );
//       } else {
//         // 🟢 Owner side (Create)
//         response = await axios.post(
//           `${BASE_URL}/ssgc-reading`,
//           formData,
//           {
//             headers: { "Content-Type": "multipart/form-data" },
//           }
//         );
//       }

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// const SsgcReading = createSlice({
//     name: "SsgcReading",
//     initialState: {
//         loading: false,
//         SsgcReading: [],
//         error: ""
//     },
//     extraReducers: {
//         [SsgcBill.fulfilled]: (state, action) => {
//             state.SsgcReading = action.payload;
//             state.loading = false;
//         },
//         [SsgcBill.pending]: (state) => {
//             state.loading = true;
//         },
//         [SsgcBill.rejected]: (state, action) => {
//             state.error = action.error.message;
//             state.loading = false;
//         },
//     }
// });
// export default SsgcReading.reducer;